module.exports = __webpack_public_path__ + "img/masa.a27028d3.jpg";